import React, { lazy } from "react";

//lazy load
const Dashboard = lazy(() => import('../Component/Dashboard/Dashboard'));
const ClinicTables = lazy(() => import('../Component/ClinicList/ClinicTables'));
const ReviewList = lazy(() => import('../Component/ReviewList/ReviewList'));

export const authRoutes = [
  {
    path: "/",
    exact: true,
    element: <Dashboard />,
  },
  {
    path: "/clinic_list",
    exact: true,
    element: <ClinicTables />,
  },
  {
    path: "/review_list",
    exact: true,
    element: <ReviewList />,
  },
];

